// src/analytics/FbPixel.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactPixel from "react-facebook-pixel";

const pixelId = "419556408597912";

export default function FbPixelProvider({ children }) {
  const location = useLocation();

  // initialise once
  useEffect(() => {
    try {
      ReactPixel.init(pixelId, {}, { autoConfig: true, debug: false }); //
      ReactPixel.pageView(); // first load
    } catch (error) {
      console.log("Pixel Error: ", error);
    }
  }, []);

  // fire on every client‑side route change
  useEffect(() => {
    ReactPixel.pageView();
  }, [location]);

  return <>{children}</>;
}
